import { defineStore } from 'pinia';
export const useWms = defineStore('wms', () => {
  const wmsVersion = ref({});
  return {
    wmsVersion
  };
});